// GET /api/v1/public/pricing (PRD 86 slice 4): what Greenback Business costs a
// new customer, and whether it is on sale. See types/publicPricing.
//
// NO AUTHORIZATION. The endpoint is public and ignores a bearer token, so none
// is sent: a stale token must never turn a price list into a refresh-and-
// logout. apiFetch never throws on a status, so the Response is parsed, and a
// refusal (404 from an api before slice 4, 503 `pricing_unavailable` with no
// published book) throws BusinessApiError with its status and code.

import { apiGet } from '../utils/apiUtils';
import { parseData } from './businessApiCommon';
import { PublicPricing } from '../types/publicPricing';

export const PUBLIC_PRICING_PATH = '/api/v1/public/pricing';

const JSON_HEADERS = { 'Content-Type': 'application/json' };

export async function getPublicPricing({ signal }: { signal?: AbortSignal } = {}): Promise<PublicPricing> {
  const response = await apiGet(PUBLIC_PRICING_PATH, { headers: JSON_HEADERS, skipAuth: true, signal });
  return parseData<PublicPricing>(response);
}
